import { assign } from "xstate";
import { APP_TRANSITIONS } from "../constants";
import { sendHeartbeatEvent, sendPageClickEvent } from "../utils/AnalyticsUtil";
import {
  getClientIdFromURL,
  getParamsFromURL,
  getSKUIdfromURL,
  getXrModefromURL,
} from "../modules/MachineUtils";
import { ENGINE_SM } from "./EngineSM";
import { RENDERER_SM } from "./RendererSM";

export const APP_SM_CONST = {
  RENDERER: "RENDERER",
  ENGINE: "ENGINE",
  INITIAL: "INITIAL",
  ID: "APP_SM",
};

const checkAndTrigger = (actions) => {
  const mode = getParamsFromURL(actions.window, "mode");
  if (mode === "engine")
    actions.Event.sendSMEvent(APP_TRANSITIONS.ENGINE_TRANSITION);
  else actions.Event.sendSMEvent(APP_TRANSITIONS.RENDERER_TRANSITION);
};

const registerListeners = (actions) => {
  actions.Listeners.addClickListener(actions.window, () => {
    sendPageClickEvent(actions, getXrModefromURL(actions.window));
  });
  actions.Listeners.addHeartBeatListener(() => {
    sendHeartbeatEvent(actions, getXrModefromURL(actions.window));
  });
  actions.Listeners.addFocusListener(actions.window, () => {
    const timingDiff = Date.now() - actions.Tracker.getLastInteractionTime();
    if (timingDiff > 30 * 60 * 1000) {
      actions.window.location.reload();
    } else {
      actions.Listeners.addHeartBeatListener(() => {
        sendHeartbeatEvent(actions, getXrModefromURL(actions.window));
      });
    }
  });
  actions.Listeners.addBlurListener(actions.window, () => {
    actions.Listeners.removeHeartBeatListener();
  });
  actions.Listeners.addResizeListener(actions.window, () => {
    actions.ThreejsScene.windowResizeListener();
  });
};

export const APP_SM = (actions) => ({
  id: APP_SM_CONST.ID,
  initial: APP_SM_CONST.INITIAL,
  context: {
    skuId: null,
    asId: null,
    clientId: null,
    preprod: false,
  },
  states: {
    [APP_SM_CONST.INITIAL]: {
      entry: [
        () =>
          actions.Tracker.initializeAnalytics(
            !actions.window.location.href.includes("localhost"),
            getClientIdFromURL(actions.window),
            getXrModefromURL(actions.window)
          ),
        () => registerListeners(actions),
        assign({
          skuId: getSKUIdfromURL(actions),
          clientId: getClientIdFromURL(actions),
          preprod: getParamsFromURL(actions.window, "preprod"),
          asId: getParamsFromURL(actions.window, "asId"),
        }),
        () => checkAndTrigger(actions),
      ],
      on: {
        [APP_TRANSITIONS.RENDERER_TRANSITION]: APP_SM_CONST.RENDERER,
        [APP_TRANSITIONS.ENGINE_TRANSITION]: APP_SM_CONST.ENGINE,
      },
    },
    [APP_SM_CONST.RENDERER]: {
      entry: [
        (context) => {
          console.log("calling render", context);
        },
        () => actions.useAppStore.getState().setAppMode("renderer"),
      ],
      ...RENDERER_SM(actions, getSKUIdfromURL(actions)),
    },
    [APP_SM_CONST.ENGINE]: {
      entry: [() => actions.useAppStore.getState().setAppMode("engine")],
      ...ENGINE_SM(actions, getSKUIdfromURL(actions)),
    },
  },
});
